import * as math from 'mathjs';

type Array6 = [ number, number, number, number, number, number ];
type Matrix6 = [ Array6, Array6, Array6, Array6, Array6, Array6 ];

export function solve6LinearEquationByMatrix(matrix: Matrix6, constantVector: Array6) {
  const mathMatrix = math.matrix(matrix);
  const mathVector = math.matrix(constantVector);

  return math.lusolve(mathMatrix, mathVector).toArray();
}

export function multiplyMatrix(matrix1, matrix2) {
  return math.multiply(math.matrix(matrix1), math.matrix(matrix2)).toArray();
}

export function rangeIntersection(start1: number, end1: number, start2: number, end2: number) {
  if (start2 > end1 || start1 > end2) {
    return null;
  }

  const resultStart = Math.max(start1, start2);
  const resultEnd = Math.min(end1, end2);

  return [ resultStart, resultEnd ];
}

export function floatToString(number: number, maxDecimalPlaces = 3) {
  if (maxDecimalPlaces === 0) {
    return number.toFixed(0);
  }

  if (parseFloat(number.toFixed(maxDecimalPlaces)) === parseFloat(number.toFixed(maxDecimalPlaces - 1))) {
    return floatToString(number, maxDecimalPlaces - 1);
  }

  return number.toFixed(maxDecimalPlaces);
}